module.exports = {
      id: "tomato-usage",
      viewBox: "0 0 32 33",
      url: __webpack_public_path__ + "svg-sprite-ef426a51ffa8e0d9106d678bb4289730.svg#tomato",
      toString: function () {
        return this.url;
      }
    }